import { jsonldReviewRatingValue } from './JsonldStore';

export const updateJsonldReviewRatingValue = (value) => jsonldReviewRatingValue.update((oldValue) => value);
